import { render, staticRenderFns } from "./ApplicantUpdates.vue?vue&type=template&id=0568bf94&scoped=true"
import script from "./ApplicantUpdates.vue?vue&type=script&lang=js"
export * from "./ApplicantUpdates.vue?vue&type=script&lang=js"
import style0 from "./ApplicantUpdates.vue?vue&type=style&index=0&id=0568bf94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0568bf94",
  null
  
)

export default component.exports